<div class="act-cell-name-renderer" [ngClass]="{'act-cell-name-renderer-downloadable': this.litigationDocumentIsDownloadable}">
  <p (click)="!this.displayingInLogs && this.litigationDocumentIsDownloadable && this.onNameClick($event)">{{ this.nameOfAct }}</p>
  <div class="act-cell-name-renderer-icon">
    <img
      class="act-cell-name-renderer-icon-info"
      [src]="'assets/icons/info-icon.svg'"
      alt="icon d'information"
      (click)="this.onSeeMetadataClick($event)"
      [class.active]="infoIconActive"
      [ngClass]="{ 'show-on-selection': checkIfRowHasBeenSelected() }"
      style="width: 25px; height: 25px; visibility: hidden"
    />

    <lib-andromeda-menu #menus *ngIf="!displayingInLogs">
      <div menuTrigger class="trigger">
        <lib-andromeda-button
          class="option-menu-icons"
          [type]="andromedaButtonTypes.Basic"
        >
          <img
            class="act-cell-name-renderer-icon-menu"
            src="assets/icons/option-menu.svg"
            alt="icon d'information"
            [class.active]="menuIconActive"
            [ngClass]="{ 'show-on-selection': checkIfRowHasBeenSelected() }"
            (click)="onMenuIconClick()"
            style="width: 25px; height: 25px; visibility: hidden"
          />
        </lib-andromeda-button>
      </div>

      <div menuContent>
        <ng-container *ngFor="let option of menuOptions">
          <lib-andromeda-menu-option
            [attr.disabled]="option.disabled"
            (click)="onClickOnOption(option, $event)"
          >
            {{ option.label }}
          </lib-andromeda-menu-option>
        </ng-container>
      </div>
    </lib-andromeda-menu>
  </div>
</div>